export const plData = {
  title: "Polityka prywatności i plików cookie – Danghuan",
  sections: [
    {
      title: "Wprowadzenie",
      content: `
        <p>Niniejsza Polityka prywatności i plików cookie wyjaśnia, w jaki sposób Danghuan Europe S.L. ('my', 'nas', 'Danghuan') gromadzi, wykorzystuje i chroni Twoje dane osobowe podczas korzystania z naszych stron internetowych i usług. Polityka ta dotyczy mieszkańców Europejskiego Obszaru Gospodarczego (EOG) oraz Zjednoczonego Królestwa (UK) i jest zgodna z Rozporządzeniem o Ochronie Danych Osobowych (RODO / GDPR) oraz polskimi przepisami o ochronie danych osobowych.</p>
      `
    },
    {
      title: "Zakres stosowania Polityki",
      content: `
        <p>Niniejsza Polityka ma zastosowanie do:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Odwiedzających naszą stronę internetową (https://www.danghuan.eu)</li>
          <li style='margin-bottom: 8px;'>Klientów i potencjalnych klientów</li>
          <li style='margin-bottom: 8px;'>Użytkowników naszych usług wymiany (trade-in) i odsprzedaży</li>
          <li style='margin-bottom: 8px;'>Przedstawicieli partnerów biznesowych i platform współpracujących</li>
        </ul>
      `
    },
    {
      title: "Jakie dane zbieramy",
      content: `
        <p>W zależności od Twojej interakcji z nami możemy gromadzić następujące dane:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Imię i nazwisko, adres, adres e-mail, numer telefonu</li>
          <li style='margin-bottom: 8px;'>IBAN, numer konta, dane PayPal, Revolut lub inne informacje płatnicze</li>
          <li style='margin-bottom: 8px;'>Dane urządzenia (model, marka, stan, informacje cenowe, numer IMEI)</li>
          <li style='margin-bottom: 8px;'>Historię komunikacji z obsługą klienta</li>
          <li style='margin-bottom: 8px;'>Preferencje marketingowe i interakcje z kampaniami</li>
          <li style='margin-bottom: 8px;'>Adres IP, typ przeglądarki, identyfikator sesji, lokalizację</li>
          <li style='margin-bottom: 8px;'>Dane z platform: Shopify, Amazon, TEMU, Back Market</li>
        </ul>
        <p>Możemy otrzymać pewne informacje o Tobie od naszych partnerów handlowych lub logistycznych (np. Shopify, Amazon, Back Market, TEMU), gdy korzystasz z ich platform w ramach naszych usług – w tym dane zamówienia, adres dostawy i status transakcji.</p>
      `
    },
    {
      title: "Wykorzystanie danych osobowych",
      content: `
        <p>Twoje dane wykorzystujemy w celu:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Realizacji zamówień wymiany, sprzedaży lub usług</li>
          <li style='margin-bottom: 8px;'>Komunikacji dotyczącej statusu zamówienia, informacji o dostawie lub zapytań wsparcia</li>
          <li style='margin-bottom: 8px;'>Ulepszania obsługi klienta, wydajności operacyjnej i doświadczenia użytkownika</li>
          <li style='margin-bottom: 8px;'>Wypełniania obowiązków prawnych i regulacyjnych, w tym wymogów księgowych, podatkowych i sprawozdawczych</li>
          <li style='margin-bottom: 8px;'>Analizowania i monitorowania korzystania z naszych usług w celu zapobiegania oszustwom lub nadużyciom</li>
          <li style='margin-bottom: 8px;'>Komunikowania się w sprawie kampanii, aktualizacji usług lub zmian warunków, gdy jest to istotne i zgodne z prawem</li>
        </ul>
      `
    },
    {
      title: "Pliki cookie",
      content: `
        <p>Używamy plików cookie w celu ulepszenia przeglądania naszej strony i jakości świadczonych usług. Pliki cookie mogą gromadzić m.in.:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Adres IP i geolokalizację</li>
          <li style='margin-bottom: 8px;'>Identyfikatory przeglądarki / urządzenia</li>
          <li style='margin-bottom: 8px;'>Dane o zachowaniu użytkownika (odwiedzone strony, czas spędzony, kliknięcia)</li>
        </ul>
        <p>Rodzaje plików cookie:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Niezbędne technicznie pliki cookie</li>
          <li style='margin-bottom: 8px;'>Funkcjonalne pliki cookie</li>
          <li style='margin-bottom: 8px;'>Wydajnościowe pliki cookie</li>
          <li style='margin-bottom: 8px;'>Reklamowe i analityczne pliki cookie</li>
        </ul>
        <p>Możesz w każdej chwili zarządzać swoimi ustawieniami cookie lub je wycofać w przeglądarce bądź poprzez baner cookie.</p>
      `
    },
    {
      title: "Udostępnianie danych stronom trzecim",
      content: `
        <p>Udostępniamy dane partnerom płatniczym i logistycznym na podstawie konieczności umownych; oraz dostawcom analitycznym na podstawie Twojej zgody na pliki cookie.</p>
        <p>Dane mogą być przekazywane:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Partnerom płatniczym: PayPal, Revolut, VISA, Mastercard, Stripe</li>
          <li style='margin-bottom: 8px;'>Przewoźnikom i dostawcom logistyki: UPS, Correos, DPD, Royal Mail, NACEX, FedEx</li>
          <li style='margin-bottom: 8px;'>Platformom handlowym: Shopify, Amazon, TEMU, BackMarket</li>
          <li style='margin-bottom: 8px;'>Partnerom marketingowym i analitycznym: Google, Meta, TikTok, REDnote, X (Twitter), Instagram, LinkedIn</li>
          <li style='margin-bottom: 8px;'>Dostawcom IT, konsultantom i doradcom prawnym</li>
          <li style='margin-bottom: 8px;'>Organom państwowym, gdy wymaga tego prawo</li>
        </ul>
        <p>Przekazywanie danych poza EOG / UK odbywa się wyłącznie z zastosowaniem zatwierdzonych przez UE zabezpieczeń, takich jak Standardowe Klauzule Umowne (SCC).</p>
      `
    },
    {
      title: "Wykorzystanie marek i logo stron trzecich",
      content: `
        <p>Na naszej stronie internetowej wyświetlane są nazwy i logotypy marek, takich jak Apple, Samsung, OPPO, OnePlus, VIVO, Xiaomi, Google i inne – wyłącznie w celu identyfikacji urządzeń kompatybilnych z naszymi usługami wymiany lub odsprzedaży. Wszystkie znaki towarowe należą do ich prawnych właścicieli. Danghuan Europe jest niezależnym usługodawcą i nie jest powiązany, zatwierdzony ani sponsorowany przez te marki, o ile nie wskazano inaczej.</p>
        <p>Użycie tych logo ma wyłącznie charakter opisowy i nie oznacza formalnej współpracy. Wszystkie prawa do marek są zastrzeżone i nie sugerują żadnego powiązania z Danghuan.</p>
      `
    },
    {
      title: "Przechowywanie i bezpieczeństwo danych",
      content: `
        <p>Przechowujemy Twoje dane tylko tak długo, jak jest to niezbędne do realizacji wyżej wymienionych celów lub wymagane przez prawo. Stosujemy odpowiednie środki techniczne i organizacyjne w celu ochrony Twoich danych – w tym szyfrowanie, kontrolę dostępu i bezpieczne przechowywanie.</p>
      `
    },
    {
      title: "Twoje prawa",
      content: `
        <p>Zobowiązujemy się odpowiedzieć na każde uzasadnione żądanie w ciągu miesiąca. W celu ochrony prywatności możemy poprosić o potwierdzenie tożsamości.</p>
        <p>Masz prawo do:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'>Dostępu i sprostowania swoich danych</li>
          <li style='margin-bottom: 8px;'>Usunięcia danych („prawo do bycia zapomnianym”)</li>
          <li style='margin-bottom: 8px;'>Sprzeciwu wobec przetwarzania lub jego ograniczenia</li>
          <li style='margin-bottom: 8px;'>Wycofania zgody w dowolnym momencie</li>
          <li style='margin-bottom: 8px;'>Przenoszenia danych (jeśli ma zastosowanie)</li>
        </ul>
        <p>Aby skorzystać z tych praw, skontaktuj się z nami: <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></p>
      `
    },
    {
      title: "Aktualizacje Polityki",
      content: `
        <p>Możemy aktualizować niniejszą Politykę, aby odzwierciedlić zmiany przepisów lub praktyk przetwarzania danych. Aktualna wersja jest zawsze dostępna na naszej stronie internetowej.</p>
      `
    },
    {
      title: "Kontakt",
      content: `
        <p>Jeśli masz pytania lub chcesz skorzystać ze swoich praw, skontaktuj się z nami:</p>
        <ul style='list-style-type: disc; padding-left: 20px;'>
          <li style='margin-bottom: 8px;'><strong>Danghuan Europe S.L.</strong></li>
          <li style='margin-bottom: 8px;'><strong>E-mail:</strong> <a href="mailto:privacy@danghuan.eu">privacy@danghuan.eu</a></li>
          <li style='margin-bottom: 8px;'><strong>Strona internetowa:</strong> <a href="https://www.danghuan.eu" target="_blank">https://www.danghuan.eu</a></li>
        </ul>
        <p>Możesz również złożyć skargę do swojego lokalnego organu ochrony danych lub do Hiszpańskiego organu ochrony danych (Agencia Española de Protección de Datos – AEPD).</p>
      `
    },
    {
      title: "Załącznik – Rozszerzone informacje prawne i o plikach cookie",
      subsections: [
        {
          title: "1. Podstawa prawna przetwarzania danych",
          content: `
            <p>Przetwarzanie Twoich danych osobowych odbywa się na podstawie:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>Realizacji umowy (np. obsługa zamówień trade-in, wypłata należności)</li>
              <li style='margin-bottom: 8px;'>Obowiązku prawnego (np. rozliczenia podatkowe, weryfikacja tożsamości)</li>
              <li style='margin-bottom: 8px;'>Twojej zgody (np. komunikacja marketingowa, pliki cookie stron trzecich)</li>
              <li style='margin-bottom: 8px;'>Uzasadnionego interesu (np. zapobieganie oszustwom, analiza wewnętrzna, usprawnienie usług)</li>
            </ul>
          `
        },
        {
          title: "2. Zapobieganie oszustwom",
          content: `
            <p>Możemy wykorzystywać Twoje dane osobowe (np. numer seryjny urządzenia, wzorce transakcji, geolokalizację IP, właściciela IBAN) w celu wykrywania oszustw, korzystając z publicznych baz danych i usług antyfraudowych. Działania te opierają się na naszym uzasadnionym interesie w zapobieganiu kradzieży tożsamości i nadużyciom.</p>
            <p>Nie podejmujemy decyzji opartych wyłącznie na zautomatyzowanym przetwarzaniu, które mogłyby wywoływać skutki prawne.</p>
          `
        },
        {
          title: "3. Przetwarzanie danych na zewnętrznych platformach",
          content: `
            <p>Jeśli kupujesz lub sprzedajesz urządzenia za pośrednictwem platform takich jak Amazon, Shopify, TEMU czy Back Market, Danghuan może otrzymać Twoje dane zamówienia, adres wysyłki i potwierdzenie płatności przez szyfrowane API lub bezpieczny kanał administracyjny — wyłącznie w celu realizacji transakcji i wsparcia posprzedażowego.</p>
          `
        },
        {
          title: "4. Kategorie i szczegóły plików cookie",
          content: `
            <p>Pełną listę używanych przez nas plików cookie – w tym nazwę, dostawcę, cel, czas przechowywania i typ (własne lub strony trzeciej) – znajdziesz w poniższej tabeli. Zawiera ona m.in. pliki cookie analityczne Google Analytics, retargetingowe Meta oraz płatnościowe PayPal.</p>
            <table style='border-collapse: collapse; width: 100%;'>
              <thead>
                <tr>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Kategoria</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Nazwa pliku cookie</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Dostawca</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Cel</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Czas przechowywania</th>
                  <th style='border: 1px solid #ddd; padding: 8px;'>Typ</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Niezbędne</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>OptanonConsent</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Przechowuje preferencje dotyczące plików cookie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 rok</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Własne</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Niezbędne</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>session_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Utrzymuje stan sesji między stronami</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Sesja</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Własne</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Funkcjonalne</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>i18next</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>danghuan.eu</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Zapamiętuje wybrany język</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Sesja</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Własne</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Funkcjonalne</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>live_chat</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Tawk.to</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Umożliwia czat na żywo</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>6 miesięcy</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strona trzecia</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Wydajnościowe</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_ga</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Zbiera statystyki korzystania ze strony</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 lata</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strona trzecia</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Wydajnościowe</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Analytics</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Śledzi zachowanie użytkownika między sesjami</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>24 godziny</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strona trzecia</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Wydajnościowe</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_clck</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Microsoft Clarity</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Utrzymuje sesję użytkownika między stronami</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 rok</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strona trzecia</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Reklamowe</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_fbp</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Meta (Facebook)</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Wyświetla spersonalizowane reklamy na podstawie zachowania</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 miesiące</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strona trzecia</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Reklamowe</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_tt_enable_cookie</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>TikTok</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Śledzi interakcje i konwersje użytkowników</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>13 miesięcy</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strona trzecia</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Reklamowe</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_uetsid</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Bing</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Śledzi użytkowników między witrynami w celach marketingowych</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>1 dzień</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strona trzecia</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Reklamowe</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>_gcl_au</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Google Ads</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Używane do śledzenia konwersji</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>3 miesiące</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strona trzecia</td>
                </tr>
                <tr>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Reklamowe</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>__kla_id</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Klaviyo</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Identyfikuje odwiedzających w kampaniach e-mail marketingowych</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>2 lata</td>
                  <td style='border: 1px solid #ddd; padding: 8px;'>Strona trzecia</td>
                </tr>
              </tbody>
            </table>
          `
        },
        {
          title: "5. Promocje, kampanie i ankiety",
          content: `
            <p>Podczas udziału w naszych promocjach, ankietach lub konkursach możemy zbierać Twoje dane, takie jak imię, dane kontaktowe oraz dodatkowe informacje (np. wiek, lokalizacja). Dane te służą wyłącznie do przeprowadzenia akcji, kontaktu ze zwycięzcami i ulepszania przyszłych kampanii.</p>
          `
        },
        {
          title: "6. Organy nadzorcze",
          content: `
            <p>Jeśli uważasz, że Twoje prawa dotyczące danych osobowych zostały naruszone, możesz złożyć skargę do:</p>
            <ul style='list-style-type: disc; padding-left: 20px;'>
              <li style='margin-bottom: 8px;'>W Polsce: Urząd Ochrony Danych Osobowych (UODO) – <a href="https://uodo.gov.pl" target="_blank">https://uodo.gov.pl</a></li>
              <li style='margin-bottom: 8px;'>W Unii Europejskiej: odpowiedniego krajowego organu, wskazanego na stronie Europejskiej Rady Ochrony Danych (EDPB) – <a href="https://edpb.europa.eu/about-edpb/board/members" target="_blank">https://edpb.europa.eu/about-edpb/board/members</a></li>
            </ul>
          `
        }
      ]
    }
  ]
};